export namespace UiAssetApiUri {
  const BASE_URL = '/assets';

  export const GET_ACCESS_CONFIG_URL = `${BASE_URL}/access-config.json`;

  export const GET_ROUTES_ACCESS_URL = `${BASE_URL}/routes-access.json`;

  export const GET_GEO_DATA_URL = `${BASE_URL}/geo-data.json`;

  export const GET_FEATURE_TOGGLE_URL = `${BASE_URL}/feature-toggle.json`;
}
